import { jsx } from "react/jsx-runtime";
import SvgCalendar from "./calendar.svg.js";
import "../../../Button/Button.js";
import { InputControl } from "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "react";
import "../../../common/ControlBody.js";
import "@mui/material";
import "../../../SelectControl/Select/context/SelectContext.js";
import "../../../Dialog/Dialog.js";
import "../../../IconButtonNew/IconButton.js";
import "../../../../icons/24/Action/Close.js";
import "../../../../icons/24/Arrow/ChevronLeft.js";
import "../../../SelectControl/Select/components/SelectInput/SelectInput.js";
import { DATA_TEST_ID_INHERITED } from "../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../../../SelectControl/Select/MultiSelect/context/MultiSelectContext.js";
import "../../../../icons/24/System/Check.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../TextareaControl/TextareaControl.js";
import "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import "../../../Avatar/styles.js";
import "../../../CheckboxGroup/Checkbox/styles.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import "../../../Dialog/StyledDialog.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/styles.js";
import "../../../Tag/Tag.js";
import { useUsDateInputMask } from "../../shared/useUsDateInputMask.js";
import "../RangePicker/context/DateRangePickerContext.js";
import "../RangePicker/context/DateRangePickerContextActions.js";
import "../../shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../external/classnames/index.js";
import "../../../Scrollbar/Scrollbar.js";
import "../../shared/fragments/MonthYearSelector/YearSelector.js";
import "../../constants.js";
import "../DatePicker/context/DatePickerContext.js";
import "../DatePicker/context/DatePickerContextActions.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../../List/ListItem/ListItem.js";
import "../../../Nowrap.js";
import "../../../List/ListItemTree/TreeListItem.js";
import "../../../List/ListItemTree/components/Label.js";
const DateInputControl = ({
  disablePastDates,
  disableFutureDates,
  id,
  disabled,
  size,
  onChange,
  error,
  name,
  value,
  onClick,
  focus,
  hideTipText,
  fullWidth,
  sx,
  ...props
}) => {
  const maskProps = useUsDateInputMask({
    name,
    value,
    disableFutureDates,
    disablePastDates,
    onChange
  });
  return /* @__PURE__ */ jsx(
    InputControl,
    {
      className: "input-control-date",
      sx: { maxWidth: fullWidth ? void 0 : 180, ...sx },
      focus,
      hideTipText,
      onClick,
      disabled,
      size,
      error,
      id,
      name: `prevent-suggestions ${id ?? ""}`,
      startAdornment: /* @__PURE__ */ jsx(SvgCalendar, {}),
      "data-test-id": DATA_TEST_ID_INHERITED,
      ...props,
      ...maskProps
    }
  );
};
export {
  DateInputControl
};
//# sourceMappingURL=DateInputControl.js.map
